"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookPixelStep = exports.FB_PIXEL_EVENT_TYPE = void 0;
// event types are standardized: https://www.facebook.com/business/help/402791146561655?id=1205376682832142
// this is how we use them:
var FB_PIXEL_EVENT_TYPE;
(function (FB_PIXEL_EVENT_TYPE) {
    FB_PIXEL_EVENT_TYPE["Lead"] = "Lead"; /* applicant/advisor user inputs phone number */
    FB_PIXEL_EVENT_TYPE["SubmitStatedIncome"] = "SubmitStatedIncome"; /* applicant submits stated income */
    FB_PIXEL_EVENT_TYPE["CompleteRegistration"] = "CompleteRegistration"; /* applicant clicks continue on prequal offer */
    FB_PIXEL_EVENT_TYPE["IncomeSuccessfulVerification"] = "IncomeSuccessfulVerification"; /* applicant is on income verification step */
    FB_PIXEL_EVENT_TYPE["AddToCart"] = "AddToCart"; /* applicant views an offer */
    FB_PIXEL_EVENT_TYPE["Purchase"] = "Purchase"; /* applicant schedules or signs now */
    FB_PIXEL_EVENT_TYPE["Schedule"] = "Schedule"; /* Notary started */
    FB_PIXEL_EVENT_TYPE["NotarySessionSuccess"] = "NotarySessionSuccess"; /* Notary complete with success */
    FB_PIXEL_EVENT_TYPE["Subscribe"] = "Subscribe"; /* applicants account creation  */
    // Rewards
    FB_PIXEL_EVENT_TYPE["SubmitApplication"] = "SubmitApplication"; /* applicant/advisor user receives a prequal offer - also used for PQ for rewards only */
    // AvenCash
    FB_PIXEL_EVENT_TYPE["StartTrial"] = "StartTrial"; /* used for when LA within AvenCash policy is prequalified */
    // Crypto only events
    FB_PIXEL_EVENT_TYPE["CryptoConfirmOffer"] = "CryptoConfirmOffer";
    // UCC only events
    FB_PIXEL_EVENT_TYPE["UccPrequalified"] = "UccPrequalified";
    FB_PIXEL_EVENT_TYPE["UccPrequalifiedRevolver"] = "UccPrequalifiedRevolver";
    FB_PIXEL_EVENT_TYPE["UccBookedRevolver"] = "UccBookedRevolver";
    // advisor only events
    FB_PIXEL_EVENT_TYPE["AddPaymentInfo"] = "AddPaymentInfo"; /* advisor notification permission granted */
    FB_PIXEL_EVENT_TYPE["InitiateCheckout"] = "InitiateCheckout"; /* advisor dryrun PQ */
    FB_PIXEL_EVENT_TYPE["CustomizeProduct"] = "CustomizeProduct"; /* advisor Homeowner successfully submits KBA */
})(FB_PIXEL_EVENT_TYPE || (exports.FB_PIXEL_EVENT_TYPE = FB_PIXEL_EVENT_TYPE = {}));
var FacebookPixelStep;
(function (FacebookPixelStep) {
    FacebookPixelStep["Lead"] = "Lead";
    FacebookPixelStep["SubmitStatedIncome"] = "SubmitStatedIncome";
    FacebookPixelStep["PreQualification"] = "PreQualification";
    FacebookPixelStep["PreQualificationContinue"] = "PreQualificationContinue";
    FacebookPixelStep["IncomeVerified"] = "IncomeVerified";
    FacebookPixelStep["ViewOffer"] = "ViewOffer";
    FacebookPixelStep["Schedule"] = "Schedule";
    FacebookPixelStep["StartNotarization"] = "StartNotarization";
    FacebookPixelStep["SuccessNotarization"] = "SuccessNotarization";
    FacebookPixelStep["AccountCreation"] = "AccountCreation";
    // Crypto events
    FacebookPixelStep["CryptoConfirmOffer"] = "CryptoConfirmOffer";
    // Advisor events
    FacebookPixelStep["PhoneNumberSubmit"] = "PhoneNumberSubmit";
    FacebookPixelStep["OTPSuccess"] = "OTPSuccess";
    FacebookPixelStep["SSNSuccess"] = "SSNSuccess";
    FacebookPixelStep["PIISuccess"] = "PIISuccess";
    FacebookPixelStep["KBASuccess"] = "KBASuccess";
    FacebookPixelStep["HomeownerKBASuccess"] = "HomeownerKBASuccess";
    FacebookPixelStep["NotificationPermissionGranted"] = "NotificationPermissionGranted";
    FacebookPixelStep["CoffeeClaim"] = "CoffeeClaim";
    FacebookPixelStep["DryrunPreQualified"] = "DryrunPreQualified";
})(FacebookPixelStep || (exports.FacebookPixelStep = FacebookPixelStep = {}));
